import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { assetSvgPath } from 'interfaces/constants'

export const StyledTimelineDetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 40px;

  &:before {
    position: absolute;
    z-index: 1;
    top: 0;
    left: -12px;
    width: 30px;
    height: 30px;
    border: solid 1px ${theme.colors.neutral200};
    background: url('${assetSvgPath}/star-pink.svg') center center no-repeat;
    background-color: white;
    border-radius: 50%;
    content: '';
  }

  &[data-locked]:before {
    border: solid 1px ${theme.colors.neutral200};
    background: url('${assetSvgPath}/lock.svg') center center no-repeat;
    background-color: white;
  }

  &[data-active]:before {
    border: solid 1px ${theme.colors.pink700};
    background: url('${assetSvgPath}/star-white.svg') center center no-repeat;
    background-color: ${theme.colors.pink700};
  }
`
export const StyledDueDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${MediaQueries.mbUp} {
    margin-bottom: 32px;
  }
`

export const StyledExtension = styled.div`
  margin-top: 24px;

  .wrapper {
    margin-bottom: 24px;

    .introducing {
      display: flex;
      align-items: center;
      margin-bottom: 4px;

      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }

    .content {
      padding-left: 16px;

      .question {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .description {
        margin: 8px 0 12px -16px;
        overflow-y: hidden;
        transition: height 0.2s;

        .inner-description {
          padding: 12px;
          margin-top: 8px;
          background-color: ${theme.colors.neutral50};
          border-radius: ${theme.borderRadius};
        }
      }
    }
  }
`
